import { FC } from 'react';

import { EmailListProps } from './EmailList.props';

import cn from 'classnames';

export const EmailList: FC<EmailListProps> = ({ data, listClassName }) => {
  return (
    <ul className={cn(listClassName)}>
      {data.map(link => (
        <li key={link.item}>
          <a
            href={`mailto:${link.item}`}
            className="overflow-wrap break-words py-3 transition-colors duration-300 hover:text-accentMain focus:text-accentMain"
          >
            {link.item}
          </a>
        </li>
      ))}
    </ul>
  );
};
